/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import { Slide } from "pure-react-carousel";

interface Props {
  index: number;
  image: any;
  defaultImage: any;
}

const ZoomSlide: React.FC<Props> = ({ index, image, defaultImage }) => {
  const [zoom, setZoom] = useState(false);
  const [zoomX, setZoomX] = useState(0);
  const [zoomY, setZoomY] = useState(0);

  const handleMouseEnter = () => {
    setZoom(true);
  };

  const handleMouseLeave = () => {
    setZoom(false);
  };

  const calculateZoomStyle = (): React.CSSProperties => {
    if (zoom) {
      return {
        transform: `scale(1.75)`,
        transformOrigin: `${zoomX}px ${zoomY}px`,
      };
    }
    return {};
  };

  return (
    <Slide key={index} index={index}>
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={(event) => {
          const target = event.currentTarget as HTMLElement;
          const { left, top, width, height } = target.getBoundingClientRect();
          const x = event.clientX - left;
          const y = event.clientY - top;
          const clampedX = Math.min(Math.max(x, 0), width);
          const clampedY = Math.min(Math.max(y, 0), height);
          setZoomX(clampedX);
          setZoomY(clampedY);
        }}
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          zIndex: 5,
        }}
      ></div>
      <img
        src={image ? image : defaultImage}
        style={{
          width: "100%",
          aspectRatio: "1 / 1",
          ...calculateZoomStyle(),
        }}
        alt="product image"
      />
    </Slide>
  );
};

export default ZoomSlide;
